import { Box } from 'rebass';

const CodeBlock = ({ children, ...props }) => (
  <Box {...props}>
    <Box
      as="pre"
      css={`
        border-radius: 8px;
        pre, code {
          span {
            font-size: 14px !important;
          }
        }
      `}
    >
      <code className="language-jsx">
        {children}
      </code>
    </Box>
  </Box>
);

export default CodeBlock;